import { combineReducers } from "@reduxjs/toolkit";

import { IStagingState } from "Model/State/IStagingState";
import { ignoredValues, showIgnoredValuesDialog } from "./ManageIgnoredValues";
import { StagingValues } from "./StagingValues";

export const Staging = combineReducers<IStagingState>({
  ignoredValues,
  showIgnoredValuesDialog,
  values: StagingValues
});
